export const WS_CONNECTION_ERROR = 'wsConnectionError';
export const WS_CONNECTION_CLOSE = 'wsConnectionClose';
export const WS_CONNECTION_OPEN = 'wsConnectionOpen';
export const WS_MESSAGE_RECEIVED = 'wsMessageReceived';

export const WS_CONNECTION_CHANGE = 'wsConnectionChange';
export const WS_TOKEN_EXPIRED = 'wsTokenExpired';
